// Court scheduling logic

const THANKSGIVING_2026 = "2026-11-26";

// ---------- Municipal Court ----------

const MUNICIPAL_COURT_DATES_2026 = [
  "2026-04-07",
  "2026-05-05",
  "2026-06-02",
  "2026-07-07",
  "2026-08-04",
  "2026-09-01",
  "2026-10-06",
  "2026-11-03",
  "2026-12-01",
];

function getNextMunicipalCourt() {
  const today = new Date();
  const target = new Date();
  target.setDate(today.getDate() + 28);

  for (const date of MUNICIPAL_COURT_DATES_2026) {
    const d = new Date(date);
    if (d >= target) {
      return {
        court: "Saguache Municipal Court",
        date,
        time: "6:00p",
      };
    }
  }

  return null;
}

// ---------- County / State Court ----------

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function nextThursdayOnOrAfter(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0 = Sun
  const diff = (4 - day + 7) % 7;
  d.setDate(d.getDate() + diff);
  return d;
}

function formatISO(date) {
  return date.toISOString().split("T")[0];
}

function getNextCountyStateCourt({ requiresSummons }) {
  const today = new Date();

  const daysOut = requiresSummons ? 70 : 30;

  const target = addDays(today, daysOut);

  let courtDate = nextThursdayOnOrAfter(target);

  // Skip Thanksgiving
  if (formatISO(courtDate) === THANKSGIVING_2026) {
    courtDate = addDays(courtDate, 7);
  }

  return {
    court: "Saguache County Court",
    date: formatISO(courtDate),
    time: "0830a",
  };
}

// ---------- Main export ----------

export function getCourtDates2026({ jurisdiction, requiresSummons }) {

  if (jurisdiction === "MUNI_SAGUACHE") {
    const court = getNextMunicipalCourt();
    return court ? [court] : [];
  }

  if (jurisdiction === "COUNTY_SAGUACHE") {
    return [getNextCountyStateCourt({ requiresSummons })];
  }

  if (jurisdiction === "STATE_CO") {
    const court = getNextCountyStateCourt({ requiresSummons });
    return [{ ...court, court: "Saguache County Court" }];
  }

  return [];
}